export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig().public
    if(!config.epoqTenantId) {
        return
    }

    const { customer } = storeToRefs(useCustomer())
    if(customer?.value?.customerNumber) {
        const customerNumber = document.createElement('script')
        customerNumber.type = 'text/javascript';
        customerNumber.text =  `epoq_customerId = '${customer.value.customerNumber};'`;
        document.head.appendChild(customerNumber);
    }
    const epoqScriptUrl = `https://cdn.epoq.de/flow/${config.epoqTenantId}.js`
    const epoqScript = document.createElement('script')
    epoqScript.type = 'text/javascript';
    epoqScript.src = epoqScriptUrl;
    epoqScript.async = true

    document.head.appendChild(epoqScript);
})
